import { render, staticRenderFns } from "./Congratulations.vue?vue&type=template&id=a28e88f8&"
import script from "./Congratulations.vue?vue&type=script&lang=js&"
export * from "./Congratulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports